var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProficient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082",
    "data-name": "Rectangle 1082",
    width: 26.579,
    height: 37.1,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_proficient",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(340.544 221.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208-2",
    "data-name": "Group 208",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21825",
    "data-name": "Path 21825",
    d: "M14.331,12.923v8.585H11.42v-9H9.184v9H4.218l.641-.641,1.815-1.815.786-.786-.152-1.1L6.036,7.91l.638-.638L8.256,5.69l-.067-.064a7.418,7.418,0,0,1,6.143,7.3",
    transform: "translate(10.011 13.351)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21826",
    "data-name": "Path 21826",
    d: "M7.031,6.922,5.608,8.345,7.031,18.7,5.216,20.516,3.4,18.7,4.825,8.345,3.4,6.922l.186-.182h.088V6.652L5.216,5.107Z",
    transform: "translate(8.073 12.119)",
    fill: "#f2ada9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21827",
    "data-name": "Path 21827",
    d: "M2.264,6.316a5.654,5.654,0,1,1,5.654,5.65,5.656,5.656,0,0,1-5.654-5.65",
    transform: "translate(5.373 1.57)",
    fill: "#ffd0cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21828",
    "data-name": "Path 21828",
    d: "M.663,12.923A7.418,7.418,0,0,1,6.8,5.626l-.064.064L8.32,7.272l.638.638L7.686,17.166l-.152,1.1.786.786,1.815,1.815.641.641H5.662v-9H3.426v9H.663Z",
    transform: "translate(1.574 13.351)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21829",
    "data-name": "Path 21829",
    d: "M3.448,7.5a5.629,5.629,0,0,1,9-4.53A5.637,5.637,0,1,0,4.568,10.84,5.6,5.6,0,0,1,3.448,7.5",
    transform: "translate(5.373 1.572)",
    fill: "#fff3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21830",
    "data-name": "Path 21830",
    d: "M10.731,16.62H9.648A9.662,9.662,0,0,0,0,26.272V37.1H26.579V26.272a9.662,9.662,0,0,0-9.648-9.651H15.848l-.978-.975-.024-.027a7.89,7.89,0,1,0-3.11,0l-.027.027ZM7.236,34.857v-9H5v9H2.237V26.272a7.418,7.418,0,0,1,6.139-7.3l-.064.064,1.582,1.582.638.638L9.26,30.515l-.152,1.1.786.786,1.815,1.815.641.641Zm10.083-4.341-1.272-9.256.638-.638,1.582-1.582-.064-.064a7.418,7.418,0,0,1,6.139,7.3v8.585H21.434v-9H19.2v9H14.229l.644-.641L16.685,32.4l.786-.786ZM7.637,7.887a5.654,5.654,0,1,1,5.654,5.65,5.654,5.654,0,0,1-5.654-5.65m4.109,10.97v-.088l1.545-1.542L15.1,19.039l-1.42,1.424,1.42,10.36-1.811,1.815-1.815-1.815L12.9,20.463l-1.424-1.424.182-.182Z",
    transform: "translate(0 -0.001)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProficient);
export default __webpack_public_path__ + "static/media/ic_proficient.3ab42939f2575578a12da41e24ede42b.svg";
export { ForwardRef as ReactComponent };